interface Props {
  subtle?: boolean;
}

/**
 * Background ambient orbs — padrão ARYA-WPP adaptado pra paleta Trakd
 * (violet + fuchsia em vez de coral + lilac).
 */
export function AmbientOrbs({ subtle = false }: Props) {
  const alpha1 = subtle ? 0.16 : 0.28;
  const alpha2 = subtle ? 0.14 : 0.24;
  const alpha3 = subtle ? 0.08 : 0.16;

  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
      <div
        className="animate-orb-1 absolute -top-40 -left-32 h-[32rem] w-[32rem] rounded-full blur-3xl"
        style={{ background: `oklch(0.62 0.22 295 / ${alpha1})` }}
      />
      <div
        className="animate-orb-2 absolute -right-32 -bottom-40 h-[32rem] w-[32rem] rounded-full blur-3xl"
        style={{ background: `oklch(0.51 0.27 320 / ${alpha2})` }}
      />
      <div
        className="animate-orb-3 absolute top-1/2 left-1/2 h-[24rem] w-[24rem] -translate-x-1/2 -translate-y-1/2 rounded-full blur-3xl"
        style={{ background: `oklch(0.51 0.21 332 / ${alpha3})` }}
      />
    </div>
  );
}
